"use strict";
exports.__esModule = true;
exports.registerCustomStrategy = void 0;
var bottomLeft_1 = require("./strategies/bottomLeft");
var topLeft_1 = require("./strategies/topLeft");
var topRight_1 = require("./strategies/topRight");
var bottomRight_1 = require("./strategies/bottomRight");
var center_1 = require("./strategies/center");
var strategies = {};
exports.registerCustomStrategy = function (name, strategy) {
    strategies[name] = strategy;
};
function selectStrategy(mode) {
    switch (mode) {
        case "topleft":
            return topLeft_1["default"];
        case "topright":
            return topRight_1["default"];
        case "bottomleft":
            return bottomLeft_1["default"];
        case "bottomright":
            return bottomRight_1["default"];
        case "center":
            return center_1["default"];
        default:
            if (strategies[mode])
                return strategies[mode];
            throw new Error("custom strategy not found!");
    }
}
exports["default"] = selectStrategy;
